export default "__VITE_ASSET__mz6$Kc3M__"